import React from 'react';
import * as Template from './Components/Layout';
import * as Views from './Components/Views';
import { HashRouter } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import WOW from 'wow.js';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

export default function App() {
  const theme = createMuiTheme({
    typography: {
      fontFamily: ["Montserrat Alternates", "Roboto", "Helvitica", "sans-serif", "Arial"].join(',')
    }
  })
  React.useEffect(() => {
    const spinner = document.querySelector(".spinner");

    if(spinner) {
      spinner.remove();
    }

  }, [])

  React.useEffect(() => {
    const wow = new WOW();
    wow.init()
  }, []);

  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
      <Template.ScrollToTop />
      <Template.Header />
      <Template.Content>
        <Switch>
          <Route exact path="/" component={Views.Home} />
          <Route path="/about" component={Views.About} />
          <Route path="/portfolio" component={Views.Portfolio} />
          <Route path="/services" component={Views.Services} />
          <Route component={Views.NotFound} />
        </Switch>
      </Template.Content>
      <Template.Footer />
      </ThemeProvider>
    </HashRouter>
  );
}

